import { useEffect, useRef, useState, useCallback } from 'react'
import { dashboardApi } from '../services/api'

const POLL_MS = 600_000

export function useDashboardTeam() {
  const [data, setData] = useState<any>(null) // TODO: type this
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<unknown>(null)
  const timer = useRef<ReturnType<typeof setInterval>>()

  const refresh = useCallback(async () => {
    try { setData(await dashboardApi.team()); setError(null) }
    catch (e: any) {
      if (e?.response?.status === 403) { setData({ forbidden: true }); setError(null) }
      else setError(e)
    } finally { setLoading(false) }
  }, [])

  useEffect(() => {
    refresh()
    timer.current = setInterval(() => { if (!document.hidden) refresh() }, POLL_MS)
    return () => clearInterval(timer.current)
  }, [refresh])

  return { data, loading, error, refresh }
}
